import gql from 'graphql-tag';

export default gql`
    mutation($organizationId: String!, $addressId: String!) {
        deleteAddressBookRecord(organizationId: $organizationId, addressId: $addressId ) {
            code
        }
    }
`;
